<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card v-can="'view-project-brief'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
          class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search" placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full" />
            </div>
            <!-- <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select :clearable="true" placeholder="" v-model="filters['status']"
                :options="['Pending', 'Approved', 'Expired', 'Rejected']"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div> -->
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">Date Range</label>
              <v-select :clearable="true" placeholder="" v-model="range_filter_value"
                :options="ranges" label="key" :reduce="option => option.value"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="fetchProjectBrief"></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {  } ; range_filter_value = null">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card>
          <div v-can="'view-project-brief'" slot="no-body" class="mt-4">
            <vs-table :data="request_list" :sst="true" :max-items="(meta.per_page) ? meta.per_page : 10"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%">CREATED DATE</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th width="5%">CUSTOMER</vs-th>
                <vs-th width="10%">REQUESTED AMOUNT</vs-th>
                <vs-th width="5%">REASON FOR CHANGE</vs-th>
                <vs-th width="10%">VALID TILL</vs-th>
                <vs-th width="10%">REQUEST STATUS</vs-th>
                <vs-th width="10%">STATUS CHANGED REASON</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr"
                  v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by }}
                  </vs-td>

                  <vs-td>
                    <HyperLink :id="data[indextr].customer_id" type="customer">
                        {{ data[indextr].customer_name }} <br>
                        {{ data[indextr].customer_account_number }}
                    </HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].change_to">
                    {{ data[indextr].change_to }}
                  </vs-td>

                  <vs-td :data="data[indextr].reason_for_change">
                    {{ data[indextr].reason_for_change }}
                  </vs-td>

                  <vs-td :data="data[indextr].valid_till">
                    {{ data[indextr].valid_till }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].status }}
                  </vs-td>

                  <vs-td :data="data[indextr].status_reason">
                    {{ data[indextr].status_reason }}
                  </vs-td>

                  <vs-td>
                    <vx-tooltip class="mr-2" text="VIEW CREDIT REQUEST" position="left" >
                        <vs-button @click.stop="onClickRequest(data[indextr].customer_id)" size="small" color="primary"
                          type="border" icon-pack="feather" icon="icon-external-link"></vs-button>
                      </vx-tooltip>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const CustomerRepository = RepositoryFactory.get('customer')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'CreditLimitRequestList',
  data() {
    return {
      request_list: [],
      filters: {},
      range_filter_value: null,
      ranges: [],
      meta: {},
      page : 1,
      total: 0,
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  methods: {
    async refreshData() {
      this.fetchProjectBrief()
    },

    async fetchProjectBrief() {
      this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getCustomerCreditLimitRequests(this.page, this.perPage, this.filterQuery + `${this.range_filter_value ? this.range_filter_value : ''}`)
        this.request_list = data.data
        this.meta = data.meta
      } catch (error) {
        this.convertAndNotifyError(error);
      }
      this.$vs.loading.close()
    },
    filterQueryUpdate() {
      this.fetchProjectBrief()
    },
    dueDateGenerate(date) {
      if (!date) return ''
      let now = moment()
      let ddd = moment(date, 'DD/MM/YYYY')
      let gap = ddd.diff(now, 'days')
      return 0 <= gap && gap <= 5 ? 'text-danger' : ''
    },
    rangeGenerator() {
      const today = moment().format('DD/MM/YYYY')
      const next_30_days = moment(today, 'DD/MM/YYYY').add(1, 'months').format('DD/MM/YYYY')
      const next_60_days = moment(today, 'DD/MM/YYYY').add(2, 'months').format('DD/MM/YYYY')
      this.ranges = [
        { key: 'Next 30 days', value: `&filter[from]=${today}&filter[to]=${next_30_days}` },
        { key: '30-60 days', value: `&filter[from]=${next_30_days}&filter[to]=${next_60_days}` },
        { key: 'More than 60 days', value: `&filter[from]=${next_60_days}` },
        { key: 'Already expired', value: `&filter[to]=${today}` }
      ]
    },
    onClickRequest(customer_id) {
      this.$router.push(`/pages/manage-nimble/customers/${customer_id}?step=5`)
    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
  },
  mounted() {
    this.setFilterId('credit_limit_request_list_filters',['search'])
    this.rangeGenerator()
  },
  watch : {
    page(){
      this.fetchProjectBrief()
    },
    perPage() {
      this.fetchProjectBrief()
    },
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
